<template>
  <div
    ref="chart"
    class="chart"
    style="height: 100%"
    v-loading="isLoading"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "charts3",
  data() {
    return {
      chart: null,
      isLoading: false,
      screenLength: 10,
    };
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    // 初始化图表
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      // 配置图表选项
      const option = {
        tooltip: {
          // 触发方式：'item'-项模式，'axis'-坐标轴模式
          trigger: "axis",

          // 自定义格式化函数
          formatter: (params) => {
            // console.log(params, "测试");
            let result = `<div style="display:flex;font-weight:bold;line-height:16px;">生产序号:${
              params[0].axisValue
            }</div>
             <div style="display:flex;align-items:center;margin:5px 0;">
                                <span style="font-size:12px;line-height:12px;color:#909399;margin-left:5px;">${this.dataList[
                                  params[0].dataIndex
                                ].createTime.replace("T", " ")}</span>
                            </div>`;
            params.forEach((item, index) => {
              // console.log(item, "测试123");
              result += `
                            <div style="display:flex;align-items:center;margin:5px 0;line-height:16px;">
                                <span style="display:inline-block;margin-right:8px;border-radius:50%;width:12px;height:12px;background:${
                                  item.color
                                };"></span>
                                <span style="font-weight:bold;color:${
                                  item.color
                                };margin-left:5px;">${item.value}%(${
                ["工序得率", "工序原料损耗率", "工序产出损耗率"][index]
              })</span>
                            </div>
                            `;
            });
            return result;
          },

          // 背景色和边框
          backgroundColor: "rgba(255, 255, 255, 0.97)",
          borderColor: "#eaeaea",
          borderWidth: 1,

          // 文本样式
          textStyle: {
            color: "#333",
            fontSize: 14,
          },

          // 内边距
          padding: [10, 15],

          // 阴影
          shadowBlur: 8,
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowOffsetX: 0,
          shadowOffsetY: 3,

          // 提示框箭头
          extraCssText:
            "box-shadow: 0 5px 25px rgba(0, 0, 0, 0.12); border-radius: 8px;",
        },
        xAxis: {
          type: "category",
          data: this.dataList.map((v) => v.name),
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %",
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        legend: {
          data: ["工序得率", "工序原料损耗率", "工序产出损耗率"],
        },
        dataZoom: [
          {
            type: "inside", // 内置型数据区域缩放组件
            xAxisIndex: [0], // 控制第一个x轴
            // yAxisIndex: [0], // 如果需要同时控制y轴缩放，可以取消注释。默认可能不控制y轴，根据需要设置。
            zoomLock: false, // 为false时既能缩放也能平移。设为true则只能平移不能缩放
            zoomOnMouseWheel: true, // 通过鼠标滚轮缩放
            moveOnMouseMove: true, // 通过鼠标拖拽平移
            // throttle: 100, // 设置触发视图刷新的频率，单位为毫秒（ms），可根据性能需要调整
            // start: 0, // 数据窗口范围的起始百分比。范围：0 ~ 100
            // end: 100, // 数据窗口范围的结束百分比。范围：0 ~ 100
            // filterMode: 'filter', // 缩放时过滤数据的方式。'filter'：数据被过滤掉，可能影响其他轴范围。
          },
        ],
        series: [
          {
            name: "工序得率",
            data: this.dataList.map((v) => v.y1),
             smooth: true,
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#8980c1",
            },
            // ["#36c17c", "#0081ff", "#a27ce6", "#fbc90d", "#e9595d"][i]
            lineStyle: {
              color: "#8980c1",
              width: 3,
              shadowColor: "rgba(0, 0, 0, 0.2)",
              shadowBlur: 8,
              shadowOffsetY: 5,
            },
          },
          {
            name: "工序原料损耗率",
            data: this.dataList.map((v) => v.y2),
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#ccb38f",
            },
            // ["#36c17c", "#0081ff", "#a27ce6", "#fbc90d", "#e9595d"][i]
            lineStyle: {
              color: "#ccb38f",
              width: 3,
              shadowColor: "rgba(0, 0, 0, 0.2)",
              shadowBlur: 8,
              shadowOffsetY: 5,
            },
          },
          {
            name: "工序产出损耗率",
            data: this.dataList.map((v) => v.y3),
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#cc8fb3",
            },
            // ["#36c17c", "#0081ff", "#a27ce6", "#fbc90d", "#e9595d"][i]
            lineStyle: {
              color: "#cc8fb3",
              width: 3,
              shadowColor: "rgba(0, 0, 0, 0.2)",
              shadowBlur: 8,
              shadowOffsetY: 5,
            },
          },
        ],
      };

      this.chart.setOption(option);

      // 监听dataZoom事件
      this.chart.on("dataZoom", this.handleDataZoom);
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>

<style>
</style>